import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';

import { registerField } from 'core/forms';

import { Typo } from 'uikit/content';

import styles from '../styles/formFieldRadioLarge.module.scss';

const FormFieldRadioLarge = ({ fieldId, schema, updateField, value = null }) => (
  <div className={styles.element}>
    {schema.options.map((option) => {
      const { getIsDisabled, isDisabled, value: optionValue } = option;
      const id = `${fieldId}-${optionValue}`;
      const isSelected = value === optionValue;

      const disabled = typeof getIsDisabled === 'function' ? getIsDisabled() : isDisabled;

      return (
        <div className={styles.option} key={optionValue}>
          <input
            checked={isSelected}
            className={styles.input}
            disabled={disabled}
            onChange={() => updateField(optionValue)}
            id={id}
            type="radio"
            value={optionValue}
          />
          <label
            className={classnames(styles.label, {
              [styles.isDisabled]: disabled,
              [styles.isSelected]: isSelected,
            })}
            htmlFor={id}
          >
            {isSelected ? (
              <RadioButtonChecked className={styles.icon} sx={{ height: 18, width: 18 }} />
            ) : (
              <RadioButtonUnchecked className={styles.icon} sx={{ height: 18, width: 18 }} />
            )}
            <div className={styles.text}>
              <Typo element="span" variant="s03">
                {option.label}
              </Typo>
              <Typo color="secondary" className={styles.description} element="span" variant="b01">
                {option.description}
              </Typo>
            </div>
          </label>
        </div>
      );
    })}
  </div>
);

FormFieldRadioLarge.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    options: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        getIsDisabled: PropTypes.func,
        isDisabled: PropTypes.bool,
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
      }),
    ),
  }).isRequired,
  updateField: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
};

registerField('RadioLarge', React.memo(FormFieldRadioLarge));

export default React.memo(FormFieldRadioLarge);
